import './head.scss'
export default function Head({ title }) {


    return (
        <h2 className="head">
            {title}
        </h2>
    )
}